import styled from "styled-components";
import { theme } from "../theme/semanticTheme";

/**
 * Atom: Card – base container for content. Reusable across Overview, reports, etc.
 */
export const Card = styled.div`
  background: ${theme.colors.background};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.borderRadius.lg};
  padding: ${theme.spacing.lg};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
`;

export const CardHighlight = styled(Card)`
  background: ${theme.colors.accentLight};
  border-color: rgba(57, 0, 149, 0.15);
`;
